/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Checkbox, createStyles, FormControlLabel, FormGroup, Grid, makeStyles, Theme } from '@material-ui/core';
import { FormApi } from 'final-form';
import gql from 'graphql-tag';
import React, { useState } from 'react';
import { useMutation } from 'react-apollo';
import { AnyObject, Field, Form, FormSpy } from 'react-final-form';
import { showNotification } from '../../App';
import { RvLoader } from '../../components/Loader';
import { DataPublisherSettings } from '../ApplicationSettingsRepository';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flex: 1,
            flexFlow: 'column',
            padding: '0 30px',
        },
        textField: {
            width: '100%'
        },
        buttonWrapper: {
            margin: '0 -10px',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            '& > button': {
                margin: '0 10px',
            }
        },
        loaderWrapper: {
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
        },
        formGroup: {
            alignItems: 'flex-start',
            '& .MuiFormControlLabel-root': {
                marginLeft: 0,
            }
        }
    })
);

interface FormState {
    publishFinancials: boolean;
    publishTimeline: boolean;
    timeOnly: boolean;
}
interface DataPublishingTabState {
    isLoading: boolean;
    isFormChanged: boolean;
    onSubmitLoading: boolean;
}

interface DataPublishingTabProps {
    data: DataPublisherSettings | null;
    onSave?: (data: DataPublisherSettings | null) => void;
}

export default function DataPublishingTab(props: DataPublishingTabProps) {

    const classes = useStyles();

    const [state, setState] = useState<DataPublishingTabState>({
        isLoading: false,
        isFormChanged: false,
        onSubmitLoading: false,
    });

    const [formState] = useState<FormState>({
        publishFinancials: props.data && props.data.config ? props.data.config.publishFinancials : false,
        publishTimeline: props.data && props.data.config ? props.data.config.publishTimeline : false,
        timeOnly: props.data && props.data.config ? props.data.config.timeOnly : false
    });

    // tslint:disable-next-line: no-any
    const [uodateDataPublisherMutation] = useMutation<any, DataPublisherSettingsMutationParams>(DATA_PUBLISHER_MUTATION);

    // tslint:disable-next-line: no-any
    const onFormValueChanged = (changeProps: any) => {
        if (!changeProps.pristine) {
            setState((prevState) => {
                return {
                    ...prevState,
                    isFormChanged: true
                };
            });
        }
    };

    // tslint:disable-next-line: no-any
    // const required = (value: any) => {
    //     return value ? undefined : 'Required';
    // };

    const onReset = (form: FormApi<FormState>) => () => {
        form.setConfig('keepDirtyOnReinitialize', false);
        form.batch(() => {
            form.reset();
        });
        form.setConfig('keepDirtyOnReinitialize', true);
    };

    const onSubmit = (form: FormApi<FormState>, values: AnyObject) => {
        // tslint:disable-next-line: no-console
        uodateDataPublisherMutation({
            variables: {
                publishFinancials: values.publishFinancials,
                publishTimeline: values.publishTimeline,
                timeOnly: values.timeOnly
            }
        })
        // tslint:disable-next-line: no-any
        .then((results: { data?: any }) => {
            if (results.data) {
                showNotification(null, 'Successfully submitted', 'info');  
                if (props.onSave && props.data) {
                    const tempData = props.data;
                    tempData.config.publishFinancials = values.publishFinancials;
                    tempData.config.publishTimeline = values.publishTimeline;
                    tempData.config.timeOnly = values.timeOnly;
                    props.onSave(tempData);
                }    
            }
        })
        // tslint:disable-next-line:no-any
        .catch((reason: any) => {
            showNotification('Failed to update data pushlisher.', reason, 'error');
            setState((_prevState) => {
                return {
                    ..._prevState,
                    onSubmitLoading: false
                };
            });
        });
    };

    return (
        <div className={classes.root}>
            {state.isLoading ? (
                <div className={classes.loaderWrapper}>
                    <RvLoader />
                </div>
            ) : (
                <Form
                    onSubmit={(values, form: FormApi<FormState>) => onSubmit(form, values)}  
                    initialValues={formState}
                    initialValuesEqual={() => true}
                    keepDirtyOnReinitialize={true}
                    subscription={{
                        submitting: true,
                        pristine: true
                    }}
                    render={({
                        handleSubmit,
                        form,
                        submitting,
                        pristine,
                        values
                    }) => (
                            <form onSubmit={handleSubmit} id="DataPublishingTab">
                                <FormSpy 
                                    subscription={{ pristine: true }}
                                    // tslint:disable-next-line: no-shadowed-variable
                                    onChange={props => {
                                        onFormValueChanged(props);
                                    }}
                                />
                                
                                <Grid container={true} spacing={3}>
                                    <Grid item={true} xs={12} md={12} justify="flex-start">
                                        <FormGroup
                                            className={classes.formGroup}
                                        >
                                            <Field
                                                name="publishFinancials"
                                                subscription={{touched: true, error: true, value: true}}
                                            >                                            
                                                {({ input, meta }) => (
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                {...input}
                                                                checked={input.value}
                                                                onChange={input.onChange}
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Publish Financials"
                                                    />
                                                )}
                                            </Field>
                                            <Field
                                                name="publishTimeline"
                                                subscription={{touched: true, error: true, value: true}}
                                            >                                            
                                                {({ input, meta }) => (
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                {...input}
                                                                checked={input.value}
                                                                onChange={input.onChange}
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Publish Timeline"
                                                    />
                                                )}
                                            </Field>
                                            <Field
                                                name="showTimerButton"
                                                subscription={{touched: true, error: true, value: true}}
                                            >                                            
                                                {({ input, meta }) => (
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                {...input}
                                                                checked={input.value}
                                                                onChange={input.onChange}
                                                                color="primary"
                                                            />
                                                        }
                                                        label="timeOnly"
                                                    />
                                                )}
                                            </Field>
                                        </FormGroup>
                                    </Grid>
                                    <Grid item={true} xs={12} md={12} justify="flex-end">
                                        <div className={classes.buttonWrapper}>
                                            <Button 
                                                variant="outlined" 
                                                color="primary"
                                                type="submit"
                                                disabled={submitting || pristine || state.onSubmitLoading}
                                            >
                                                Save
                                            </Button>
                                            <Button 
                                                variant="outlined" 
                                                color="primary"
                                                type="button"
                                                disabled={submitting || pristine}
                                                onClick={onReset(form)}
                                            >
                                                Reset
                                            </Button>
                                        </div>
                                    </Grid>
                                    {/* {printJson(values)} */}
                            </Grid>
                            </form>
                        )}
                />
            )}
        </div>
    );
}

// tslint:disable-next-line: no-any
export function printJson(values: any) {
    if (values) {
        return (
            <>
                <pre>
                    {JSON.stringify(values, undefined, 2)}
                </pre>
            </>
        );
    } else {
        return (
            <>
                <FormSpy subscription={{ values: true }}>
                    {/* tslint:disable-next-line: no-shadowed-variable */}
                    {({ values }) => (
                        <pre>
                            {JSON.stringify(values, undefined, 2)}
                            {/* <RenderCount /> */}
                        </pre>
                    )}
                </FormSpy>
            </>
        );
    }
}

interface DataPublisherSettingsMutationParams {
    publishFinancials: boolean;
    publishTimeline: boolean;
    timeOnly: boolean;
}

const DATA_PUBLISHER_MUTATION = gql`
    mutation DataPublisherSettingsMutation(
        $publishFinancials:  Boolean,
        $publishTimeline:  Boolean,
        $timeOnly: Boolean
    ) {
        applicationSettings {
            dataPublisherSettings {
                update (
                    publishFinancials: $publishFinancials,
                    publishTimeline: $publishTimeline,
                    timeOnly: $timeOnly
                ) {
                    error
                    status
                }
            }
        }
    }
`;